<div class="pt-4 text-center" style="max-width: 400px">
    <!--loading-->
    <div *ngIf="viewState == viewStates.loading" class="p-8">
        <mat-spinner class="ml-auto mr-auto"></mat-spinner>
    </div>

    <ng-container *ngIf="viewState != viewStates.loading">
        <mat-icon
            class="icon-modal {{ modalIconColor() }}"
            [svgIcon]="modalIcon()"
        ></mat-icon>

        <div mat-dialog-title class="mt-4">
            <b>{{ title }}</b>
        </div>

        <div mat-dialog-content>
            <p *ngIf="text">{{ text }}</p>
        </div>

        <div mat-dialog-actions class="flex items-center justify-center">
            <button
                *ngIf="!isComplete && (input.showCancelButton ?? true)"
                mat-button
                (click)="onDismiss()"
            >
                {{ input.cancelButtonText ?? "Cancel" }}
            </button>
            <button
                *ngIf="!isComplete"
                mat-flat-button
                color="primary"
                class="{{ modalConfirmButtonClass() }}"
                (click)="onConfirm()"
            >
                {{ input.confirmButtonText ?? "Confirm" }}
            </button>
            <button
                *ngIf="isComplete"
                mat-flat-button
                color="primary"
                class="{{ modalConfirmButtonClass() }}"
                (click)="onDismiss()"
            >
                Close
            </button>
        </div>
    </ng-container>
</div>
